<template>
  <div>
    <v-row>
      <v-col cols="6">
        <h1 class="headline font-weight-light mb-3">
          <router-link class="link-a" :to="'/Inventory/Issue'">
            View DocumentEngineer</router-link
          >
          / PRINT
        </h1>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="6" class="text-right">
        <v-btn rounded small @click="print()">
          <v-icon class="mr-1" dark small>mdi-printer</v-icon>
          Print</v-btn
        >
      </v-col>
    </v-row>
    <div id="printDiv">
      <!-- ที่เขียน inline เพราะ css ไม่ยอมทำงานตอนปริ้น -->
      <div align="center" class="style2">
        <br />
        <br /><!-- 
        <div align="right">
            <span style="font-size: 15px;font-weight:bold;">เลขที่เอกสาร DOC20060355</span>
            <input type="hidden" id="no_doc" name="no_doc" value="DOC20060355">
            <input type="hidden" id="id_no_doc" name="id_no_doc" value="1">
        </div>
        <br> -->
        <div>
          <div
            align="center"
            style="background-color: #f0d463;font-size: 17px;font-weight:bold;"
          >
            ใบนำส่งเอกสาร
          </div>

          <div align="center">
            <table width="100%" frame="box">
              <tbody>
                <tr>
                  <td>ชื่อศูนย์บริการ :</td>
                  <td>SVC</td>
                  <td>สนานที่ :</td>
                  <td>อาคารศรีเฟื้องฟุ้ง ชั้น 7B</td>
                </tr>
                <tr>
                  <td>จังหวัด :</td>
                  <td></td>
                  <td>ผู้ติดต่อ :</td>
                  <td>Admin BKK</td>
                </tr>
                <tr>
                  <td>หมายเลขโทรศัพท์ :</td>
                  <td></td>
                  <td>หมายเลขโทรศัพท์ :</td>
                  <td>063-4740564 (Admin Non HP)</td>
                </tr>
                <tr>
                  <td>วันที่จัดส่ง :</td>
                  <td>10/06/2020</td>
                  <td></td>
                  <td>090-1973266 (Admin Non HP)</td>
                </tr>
                <tr>
                  <td>ชื่อ :</td>
                  <td>Chainarong Yenchuen</td>
                  <td></td>
                  <td>094-4903450 (Admin HP)</td>
                </tr>
                <tr>
                  <td>รหัสพนักงาน :</td>
                  <td>P14-030</td>
                  <td></td>
                  <td>083-0967023 (Admin HP)</td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
          <div align="center">
            <table width="100%" border="1">
              <tbody>
                <tr align="center" style="background-color: #f0d463;">
                  <td width="5%" style="font-size: 12 ;font-weight:bold;">
                    No.
                  </td>
                  <td width="7%" style="font-size: 12 ;font-weight:bold;">
                    Project
                  </td>
                  <td width="13%" style="font-size: 12 ;font-weight:bold;">
                    Case
                  </td>
                  <td width="9%" style="font-size: 12 ;font-weight:bold;">
                    CSO No.
                  </td>
                  <td width="54%" style="font-size: 12 ;font-weight:bold;">
                    Site
                  </td>
                  <td width="9%" style="font-size: 12 ;font-weight:bold;">
                    Engineer
                  </td>
                  <td width="3%" style="font-size: 12 ;font-weight:bold;">
                    จำนวน
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <br />
            <table width="100%">
              <tbody>
                <tr>
                  <td width="3%">ลงชื่อ</td>
                  <td width="15%" style="border-bottom: 1px solid #000;"></td>
                  <td width="15%" style="border-bottom: 1px solid #000;"></td>
                  <td width="17%">ผู้ฝากส่งเอกสาร</td>
                  <td width="2%"></td>
                  <td width="3%">ลงชื่อ</td>
                  <td width="15%" style="border-bottom: 1px solid #000;"></td>
                  <td width="15%" style="border-bottom: 1px solid #000;"></td>
                  <td width="17%">ผู้รับเอกสาร</td>
                </tr>
                <tr>
                  <td></td>
                </tr>
                <tr>
                  <td>วันที่</td>
                  <td style="border-bottom: 1px solid #000;"></td>
                  <td style="border-bottom: 1px solid #000;"></td>
                  <td></td>
                  <td></td>
                  <td>วันที่</td>
                  <td style="border-bottom: 1px solid #000;"></td>
                  <td style="border-bottom: 1px solid #000;"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import { mapState, mapMutations } from "vuex";
import VueHtmlToPaper from "vue-html-to-paper";

const options = {
  name: "_blank",
  specs: ["fullscreen=no", "titlebar=no", "scrollbars=no"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
  ],
};

export default {
  mounted() {},
  ...mapMutations(["mutateMiniSidebar"]),
  methods: {
    print() {
      this.$htmlToPaper("printDiv");
    },
  },
  data() {
    return {
      data_print: [],
    };
  },
};
</script>
<style scoped>
.spacing-playground .v-select .v-input__prepend-outer,
.spacing-playground .v-select .v-input__append-outer {
  margin-top: 0.55rem;
  margin-right: 0.2rem;
}
body {
  margin: 0 !important;
}
</style>
